export default __webpack_public_path__ + "static/media/blue-marker.53ab11ec.svg";